/* Lumix (15.10.2026): Die Warenkorb-Leiste unten erscheint, sobald der Haupt-"In den Warenkorb"-Button der Produktseite
   nach oben aus dem Sichtbereich gescrollt ist (vorher erst, wenn die ganze Produktinfo-Spalte vorbei war).
   Faellt der Button nicht zu finden, gilt das alte Verhalten. Ueber dem Footer bleibt die Leiste weiterhin ausgeblendet. */
if (!window.Maximize.loadedScript.includes('sticky-atc.js')) {
  window.Maximize.loadedScript.push('sticky-atc.js');

  requestAnimationFrame(() => {
    const defineStickyAtc = () => {
      Alpine.store('stickyATC', {
        isOpen: false,
        isFooterShow: false,
        isProductInfoOutOfView: false,
        isOpenDetailOnMobile: false,
        _observer: null,
        _btnObserver: null,
        handleInit(sectionId) {
          if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
          }
          if (this._btnObserver) {
            this._btnObserver.disconnect();
            this._btnObserver = null;
          }

          this.scrollY = window.scrollY;
          let contentWrapperEle = document.querySelector(`.section--${sectionId} .product-template__content-wrapper`);
          let mediaWrapperEle = document.querySelector(`.section--${sectionId} .product-template__media-wrapper`);
          let productDetailsEle = document.querySelector(`.section-main-product + .section-product-details product-details`);
          const footerElement = document.getElementById("x-footer");
          const sectionElements = document.querySelectorAll(".x-bundle-section");
          const visibleSections = new Set();
          const mainAtcBtn = contentWrapperEle
            ? contentWrapperEle.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]')
            : null;

          const update = () => {
            const isAnySectionVisible = window.innerWidth < MIN_DEVICE_WIDTH.desktop && visibleSections.size > 0;
            this.isOpen = !this.isFooterShow && this.isProductInfoOutOfView && !isAnySectionVisible;
          };

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target.classList.contains('x-bundle-section')) {
                  if (entry.isIntersecting) {
                    visibleSections.add(entry.target);
                  } else {
                    visibleSections.delete(entry.target);
                  }
                }
                else if (!mainAtcBtn && (entry.target === contentWrapperEle || entry.target === mediaWrapperEle || entry.target === productDetailsEle)) {
                  const contentBottom = contentWrapperEle?.getBoundingClientRect().bottom ?? 0;
                  const mediaAndDetailsEl = productDetailsEle || mediaWrapperEle;
                  const mediaAndDetailsBottom = mediaAndDetailsEl?.getBoundingClientRect().bottom ?? 0;

                  if (contentBottom <= mediaAndDetailsBottom && entry.target === mediaAndDetailsEl) {
                    this.isProductInfoOutOfView = !entry.isIntersecting && (mediaAndDetailsBottom < window.innerHeight);
                  } else if (contentBottom > mediaAndDetailsBottom && entry.target === contentWrapperEle) {
                    this.isProductInfoOutOfView = !entry.isIntersecting && (contentBottom < window.innerHeight);
                  }
                } else if (entry.target.id === "x-footer") {
                  this.isFooterShow = entry.isIntersecting;
                }
              });
              update();
            },
            {root: null, threshold: 0, rootMargin: "0px 0px -10px 0px"}
          );

          this._observer = observer;

          if (footerElement) {
            observer.observe(footerElement);
          }
          if (!mainAtcBtn) {
            if (productDetailsEle) {
              observer.observe(productDetailsEle);
            } else if (mediaWrapperEle) {
              observer.observe(mediaWrapperEle);
            }
            if (contentWrapperEle) observer.observe(contentWrapperEle);
          }
          sectionElements.forEach(el => {
            if (el) observer.observe(el);
          });

          if (mainAtcBtn) {
            /* oben 80 px Abstand fuer die feste Kopfleiste: verschwindet der Button darunter, gilt er als nicht mehr sichtbar */
            const btnObserver = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  this.isProductInfoOutOfView = !entry.isIntersecting && entry.boundingClientRect.bottom < 80;
                });
                update();
              },
              {root: null, threshold: 0, rootMargin: "-80px 0px 0px 0px"}
            );
            btnObserver.observe(mainAtcBtn);
            this._btnObserver = btnObserver;
          }
        }
      })

      Alpine.data('xStickyATC', (stickyATCContainerEl, sectionId, hasOnlyDefaultVariant) => ({
        isOpenDetailOnMobile: false,
        isFirstLoading: true,
        isMobile: window.innerWidth < MIN_DEVICE_WIDTH.desktop,
        availableOptions: [],
        variantOptionsEle: [],
        options: [],
        optionsSelectedValues: [],
        init() {
          this.optionElements = this.$el.querySelectorAll(`#StickyAddToCart__Variant__${sectionId} .variant-option`)
          this.optionsSelectedValues = this.updateOptionSelectedValues();

          const isMobile = window.matchMedia(`(max-width: ${MIN_DEVICE_WIDTH.desktop - 1}px`);

          const handleMediaChange = (e) => {
            if (e.matches && !hasOnlyDefaultVariant) {
              this.isMobile = true;
              if (!this.isFirstLoading) Alpine.store("stickyATC").isOpenDetailOnMobile = true;
            } else {
              this.isMobile = false;
              Alpine.store("stickyATC").isOpenDetailOnMobile = false;
            }
          };

          handleMediaChange(isMobile);
          isMobile.addEventListener('change', handleMediaChange);
          this.isFirstLoading = false;
        },
        selectOptionSticky(event) {
          const targetOption = event.currentTarget;
          let position = targetOption.dataset.optionPosition;

          /* V10.51: aktuelle Auswahl frisch aus der Leiste lesen (die Leiste wird beim Variantenwechsel von oben neu gerendert,
             der alte Zwischenspeicher war dann veraltet und ergab eine nicht existierende Kombination -> Sprung auf eine falsche Variante). */
          const frisch = [];
          document.querySelectorAll(`#StickyAddToCart__Variant__${sectionId} .variant-option.selected`).forEach((el) => {
            frisch[Number(el.dataset.optionPosition) - 1] = el.dataset.optionValueId;
          });
          if (frisch.length) this.optionsSelectedValues = frisch;
          this.optionsSelectedValues[Number(position) - 1] = targetOption.dataset.optionValueId;
          /* Gibt es die Kombination nicht, die naechstpassende Variante nehmen (Dachart > Speicher > weitere Auswahl bleiben moeglichst erhalten). */
          if (typeof window.__lxResolve === 'function') {
            const fix = window.__lxResolve(this.optionsSelectedValues.slice(), Number(position) - 1);
            if (fix) this.optionsSelectedValues = fix;
          }

          document.dispatchEvent(new CustomEvent(`${STICKY_ATC_EVENT.optionChange}-${sectionId}`, {
            detail: {
              optionsSelectedValues: this.optionsSelectedValues,
              productUrl: targetOption.dataset.productUrl || null
            }
          }));
        },
        updateOptionSelectedValues() {
          const newOptionsSelectedValues = [];

          this.optionElements.forEach((optionEle) => {
            const optionPosition = optionEle.dataset.optionPosition;
            const idx = Number(optionPosition) - 1;
            if (optionEle.classList.contains('selected')) {
              newOptionsSelectedValues[idx] = optionEle.dataset.optionValueId;
            }
          });

          return newOptionsSelectedValues;
        }
      }))
    };
    if (window.Alpine) {
      defineStickyAtc();
    } else {
      document.addEventListener('alpine:init', defineStickyAtc);
    }
  })
}

